import axios, { AxiosRequestConfig } from 'axios';

const API_TOKEN = process.env.VUE_APP_API_TOKEN || '';
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '';

if (!API_BASE_URL) {
    console.warn('VUE_APP_API_BASE_URL is not set.');
}

// Create axios instance
const axiosInstance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${API_TOKEN}`
    }
});

// Add request interceptor to attach token
axiosInstance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        if (!config.headers) {
            config.headers = {};
        }
        if (API_TOKEN) {
            config.headers.Authorization = `Bearer ${API_TOKEN}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default axiosInstance;
